const KelasSearch = {
    idKelas: null,
    namaKelas: null,
    kodeJenjangSekolah: null,
    kodeJurusan: null,
    tingkatanKelas: null
};

export default KelasSearch;